import { render, staticRenderFns } from "./v-label.vue?vue&type=template&id=7ce5bb02"
import script from "./v-label.vue?vue&type=script&lang=js"
export * from "./v-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports